export function podeAcessarRadarExecucao(config, groupsConfig, isFullAdmin = false) {
  return Boolean(config && config.radarExecucao &&
    (isFullAdmin || (groupsConfig && groupsConfig.radarExecucao)));
}

export function radarExecucaoInicial(banco) {
  return banco === 'sc' || banco === 'cidade-empreendedora-sc';
}

export function ordenarRadarAposPainelExecucao(items) {
  const ordered = [...items];
  const radar = ordered.findIndex(item => item.radarExecucaoOnly);
  const painel = ordered.findIndex(item => item.externalLinkType === 'painelExecucao');
  if (radar < 0 || painel < 0) return ordered;
  const [item] = ordered.splice(radar, 1);
  ordered.splice(ordered.findIndex(entry => entry.externalLinkType === 'painelExecucao') + 1, 0, item);
  return ordered;
}
